import api from "./axios";
import { apiPaths } from "./paths";
import type { User } from "@/types";

export const updateMyUsername = (username: string) =>
  api.put<User>(apiPaths.users.me(), { username }).then((r) => r.data);

export const deleteMyAccount = () => api.delete(apiPaths.users.me());
